import { baseURL, publishURL } from './http.js';
import request from './request.js';
export default {
  login: item => request(publishURL).post('user/login', item),
  logout: () => request(publishURL).post('user/logout'),
  userSelf: () => request(publishURL).get('user/api/user/self'),
  getEncryptPassword: item => request(baseURL).post('cUser/getEncryptPassword', item),
  updateLoginDate: () => request(baseURL).post('cUser/updateLoginDate')
}